import ExamMasterList from "../components/ExamMasterList";

export default function MasterFasilitas() {
    return (
        <ExamMasterList
            kind="fasilitas"
            title="Master Fasilitas"
            subtitle="Kelola daftar fasilitas penunjang (ruangan, konsumsi, transportasi, dll) beserta harga jual. Unit cost dasar diambil dari Unit Cost Fasilitas per kategori ruangan."
            testidPrefix="fasilitas"
            hasUnitCost={true}
            showJasaMedis={false}
        />
    );
}
